import { ProfilePreviewHeader } from "PFApp/components/profile_preview/parts/profile_preview_header";
import { SkillCategorySection } from "PFApp/components/profile_preview/parts/skills/skills_category_section";
import { Button } from "PFComponents/button";
import { Profile, ProfileCustomValue } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "./profile_preview_skills.module.scss";

type ProfilePreviewCategorizedSkillsProps = {
  skillCategories: Record<string, ProfileCustomValue[]>;
  other: ProfileCustomValue[];
  hasTopSkills: boolean;
  masterExpand: boolean;
  setMasterExpand: (value: boolean) => void;
  profile: Profile;
};

export const ProfilePreviewCategorizedSkills = ({
  skillCategories,
  other,
  hasTopSkills,
  masterExpand,
  setMasterExpand,
  profile
}: ProfilePreviewCategorizedSkillsProps) => {
  const { t } = useTranslation("core");
  const sortedCategoryNames = Object.keys(skillCategories).sort(
    // eslint-disable-next-line id-length
    (a, b) => (skillCategories[a].length > skillCategories[b].length ? -1 : 1)
  );

  return (
    <>
      <ProfilePreviewHeader
        actions={
          <Button
            kind="text"
            className={css.expandButton}
            onClick={() => setMasterExpand(!masterExpand)}
            text={masterExpand ? t("profilePreview.collapseAll") : t("profilePreview.expandAll")}
          />
        }
        headerClassName={css.header}
      >
        {hasTopSkills ? t("profilePreview.otherSkills") : t("profilePreview.skills")}
      </ProfilePreviewHeader>
      <div>
        {sortedCategoryNames.map((key) => (
          <SkillCategorySection
            key={key}
            name={key}
            values={skillCategories[key]}
            expanded={masterExpand}
            profile={profile}
          />
        ))}
        {other.length > 0 && (
          <SkillCategorySection
            name={t("profilePreview.other")}
            values={other}
            expanded={masterExpand}
            profile={profile}
          />
        )}
      </div>
    </>
  );
};
